import { defineNuxtPlugin } from '#app'

// Universal (server + client) gate that guarantees feature flags are loaded BEFORE
// the app renders, on both rendering modes:
//  - SSR routes: runs on the server, flags land in the pinia payload and hydrate on
//    the client with no re-fetch — so the server HTML and the hydrated DOM agree
//    (no hydration mismatch, no v1→v2 flash).
//  - SPA routes: runs on the client before mount; because the plugin is async and
//    blocking, nothing renders until flags are ready.
//
// `callOnce` (render mode) performs the load once during SSR and skips it on
// hydration; `ensureFlagsLoaded` is itself idempotent/deduped as a second safety net.
// Please read apps/docs/src/platform/feature-flags.md before touching this.
export default defineNuxtPlugin({
  name: 'feature-flags',
  enforce: 'pre',
  dependsOn: ['pinia'],
  async setup() {
    const auth = useAuth()
    await callOnce('load-feature-flags', () => auth.ensureFlagsLoaded())
  },
})
